<template>
  <div class="product">
    <div class="index-image">
      <div class="inner-text">
        <p class="title">生态合作</p>
        <p class="content">我们为合作伙伴提供先进的智能技术，分享成熟的增长理念，
        与合作伙伴共同探索创新解决方案，助力企业数字化转型，赋能组织智能化升级，实现业务超级增长。
        让我们共同见证增长爆发的炫目时刻！</p>
      </div>
    </div>
    <div class="index-next-content">
      <div class="inner-content">
        <div class="main-title">为什么加入我们</div>
        <div class="box-card">
          <el-card shadow="never" class="box-card-inner"
            :style="index===2?{marginRight:0}:{}"
            v-for="(item,index) in listArr" :key="index">
            <div class="title">
              <i :class="item.icon"></i>
              <div>{{item.title}}</div>
            </div>
            <div class="next-title">
              {{item.nextTitle}}
            </div>
          </el-card>
        </div>
        <div class="main-title">如何加入我们</div>
        <div class="box-card1">
          <el-steps :active="10"  align-center>
            <el-step title="账号注册" description="这是一段很长很长很长的描述性文字"></el-step>
            <el-step title="企业实名认证" description="这是一段很长很长很长的描述性文字"></el-step>
            <el-step title="选择合作类型" description="这是一段很长很长很长的描述性文字"></el-step>
            <el-step title="完成资质认证" description="这是一段很长很长很长的描述性文字"></el-step>
            <el-step title="成为合作伙伴" description="这是一段很长很长很长的描述性文字"></el-step>
          </el-steps>
        </div>
        <div class="main-title">
          <div>重点合作计划</div>
          <p class="main-next">我们在重点行业赛道和产品线推出专项合作计划，伙伴可结合自身优势选择加入</p>
        </div>
        <div class="box-card1">
          <el-card shadow="never" class="box-card-inner"
            :style="index%2==1?{marginRight:0}:{}"
            v-for="(item,index) in coreList" :key="index">
            <div class="core">
              <div class="title">
                <i :class="item.icon"></i>
              </div>
              <div class="next-title">
                <div class="next-title-one">{{item.title}}</div>
                <div>{{item.nextTitle}}</div>
              </div>
            </div>
          </el-card>
        </div>
        <div class="main-title">优秀伙伴案例</div>
        <div class="box-card2">
          <el-card shadow="never"
            :style="index===2?{marginRight:0}:{}"
            class="box-card-inner"
            v-for="(item,index) in aplicationArr" :key="index">
            <div class="title">
              <div>{{item.title}}</div>
            </div>
            <div class="next-title">
              {{item.nextTitle}}
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
      listArr: [
        {
          icon: 'el-icon-attract',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        },
        {
          icon: 'el-icon-mobile',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'

        },
        {
          icon: 'el-icon-scissors',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        }
      ],
      coreList: [
        {
          icon: 'el-icon-attract',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        },
        {
          icon: 'el-icon-mobile',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'

        },
        {
          icon: 'el-icon-scissors',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        },
        {
          icon: 'el-icon-scissors',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        }
      ],
      aplicationArr: [
        {
          icon: 'el-icon-attract',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        },
        {
          icon: 'el-icon-mobile',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'

        },
        {
          icon: 'el-icon-scissors',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.product
  padding-bottom 50px
  .index-image
     height:380px
     background-color:rgb(12, 17, 18)
     .inner-text
      padding-top 100px
      margin 0 auto
      width 880px
      color #fff
      .title
        font-size 36px
        font-weight 500
      .content
        font-size 14px
        width 500px
        line-height 30px
  .index-next-content
     width 100%
    .inner-content
      width: 900px
      margin 0 auto
      .main-title
        padding-top 50px
        height:100px
        font-size 24px
        color #000
        font-weight 600
        padding-left 12px
        .main-next
          font-size 16px
          font-weight 400
          color #4e5969
      .box-card
        color #86909c
        .box-card-inner
          text-align left
          margin 10px 15px
          width: 260px
          border-radius: 10px
          display: inline-block
          .title
            color:#000
            font-size 14px
            font-weight 600px
            margin-bottom 10px
            i
              font-size 26px
              padding-right 10px
          .next-title
            color rgba(128, 128, 128, 1)
            font-size 12px
      .box-card1
          color #86909c
          .box-card-inner
            text-align left
            margin 10px 15px
            width: 408px
            border-radius: 10px
            display: inline-block
            .core
              display flex
              .title
                font-size 80px
                font-weight 600px
                color #86909c
                margin-right 15px
              .next-title
                color rgba(128, 128, 128, 1)
                font-size 12px
                .next-title-one
                  font-size 16px
                  color:#000
                  margin-bottom 15px
      .box-card2
        color #86909c
        .box-card-inner
          text-align left
          margin 10px 15px
          width: 260px
          border-radius: 10px
          display: inline-block
          &:hover .title
            color #1664ff
          .title
            color:#000
            font-size 16px
            font-weight 600px
            margin-bottom 10px
          .next-title
            color rgba(128, 128, 128, 1)
            font-size 12px
</style>



// WEBPACK FOOTER //
// src/pages/cooperation.vue